
import  React from "react"
import { Modal, Button, List, Spin } from "antd"
import { CloseOutlined } from "@ant-design/icons"
import PropTypes from "prop-types" // Import PropTypes
import { useEffect, useState } from "react"
import dayjs from "dayjs";
import { Link } from "react-router-dom";

const MedicineViewModal = ({isOpen, onClose, patientData}) => {

  const [loading, setLoading] = useState(false);
  const [recentBills, setRecentBills] = useState([]);

  const fetchRecentBills = async () => {
    try {
      setLoading(true);
    } catch (err) {
      setLoading(false);
      // Optionally handle error
    }
  };
    
  useEffect(()=>{
    if( isOpen )
    {
      // fetchRecentBills();
    }
  },[isOpen]);

  return (
    <>
      <Modal
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              background: "#1890ff",
              margin: "-20px -24px 20px",
              padding: "10px 24px",
              color: "white",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <span>Medicine List:-</span> <span className="mx-2">{patientData?.patient?.full_name}</span>
            </div>
            <Button type="text" icon={<CloseOutlined />} onClick={onClose} style={{ color: "white" }} />
          </div>
        }
        open={isOpen}
        onCancel={onClose}
        maskClosable={false} 
        keyboard={false}
        footer={null}
        width={1200}
        styles={{ padding: "0 24px 24px" }}
        closable={false}
        centered
      >
        {loading ? (
          <div className="w-100 p-4 d-flex align-items-center justify-content-center">
            <Spin size="large" />
          </div>
        ) : (
          <>
            <List
              dataSource={recentBills}
              renderItem={(item, index) => (
                <List.Item
                  style={{
                    padding: "10px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <div>
                        {index + 1}. 
                          <Link to="#" onClick={()=>{}}>{item.doctor_bill_no}</Link> on {dayjs(item.created_at).format("DD MMM YYYY")}
                      </div>
                      <div style={{ fontWeight: "bold" }}>₹{item.payment_amount}</div>
                    </div>
                  </div>
                </List.Item>
              )}
            />
          </>
        )}
        
      </Modal>
    </>
  )
}
MedicineViewModal.propTypes = {
    isOpen: PropTypes.bool.isRequired, // isOpen must be a boolean and is required
    onClose: PropTypes.func.isRequired, // onClose must be a function and is required
    patientData: PropTypes.patientData,
  }

export default MedicineViewModal
